// Functions
import pxToRem from "assets/theme/functions/pxToRem";

// MUI Components
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

// Custom Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// 3rd party library
import PropTypes from "prop-types";
import FontComponent from "components/Responsive/fonts";

export default function CustomRadio({
  label,
  name,
  list,
  value,
  handleChange,
  defaultValue,
  style = {},
  readOnly = false,
}) {
  const fontSize = FontComponent({ sizes: {} });

  // Read-only mode: show the label and the selected option's text instead of
  // an interactive (and confusingly greyed-out) radio group.
  if (readOnly) {
    const selectedOption = list.find((item) => item?.value === value);
    return (
      <MDBox sx={{ ...style }}>
        <MDTypography
          variant="body"
          sx={{ fontSize, fontWeight: 500, color: "#344054", display: "block", mb: 1 }}
        >
          {label}
        </MDTypography>
        <MDBox
          sx={{
            display: "inline-flex",
            alignItems: "center",
            minWidth: pxToRem(46),
            height: pxToRem(30),
            px: pxToRem(14),
            borderRadius: pxToRem(8),
            backgroundColor: "#F2F4F7",
            border: "1px solid #E4E7EC",
          }}
        >
          <MDTypography variant="body" sx={{ fontSize, fontWeight: 500, color: "#101828" }}>
            {selectedOption?.label ?? "-"}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  }

  return (
    <MDBox sx={{ ...style }}>
      <MDTypography variant="body" mb={1} sx={{ fontSize, fontWeight: 500, color: "#344054" }}>
        {label}
      </MDTypography>
      <RadioGroup
        row
        aria-labelledby={name}
        name={name}
        {...(value && { value })}
        onChange={handleChange}
        defaultValue={defaultValue}
      >
        {list.map((item) => (
          <FormControlLabel
            key={item?.label.replace(/\s/g, "")}
            defaultValue={item?.value}
            value={item?.value}
            control={<Radio />}
            label={item?.label}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontWeight: 400,
              },
            }}
          />
        ))}
      </RadioGroup>
    </MDBox>
  );
}

CustomRadio.defaultProps = {
  label: "",
  name: "",
  list: [],
  value: "",
  handleChange: () => {},
  defaultValue: "",
  style: { mt: pxToRem(8) },
  readOnly: false,
};

CustomRadio.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string,
  handleChange: PropTypes.func,
  defaultValue: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  readOnly: PropTypes.bool,
};
